export default {
    formDetail: {
        path: '/form/detail',
        name: 'form-detail',
        component: () => import('@/views/form/form-detail.vue')
    }
};
